import React from 'react'
import Button from 'react-bootstrap/Button'
import ButtonLoader from '../loader/ButtonLoader'

export default function SaveButton(props) {

    const { name, spiner } = props

    return (
        <>
            <Button type='submit' size='sm' className='save_btn' disabled={spiner}>
                {spiner ?
                    <ButtonLoader />
                    :
                    name
                }
            </Button>
        </>
    )
}
